import React, {useEffect, useState} from "react";
import { Form, Col, Input,Card, Table, Collapse} from 'antd';
import jsonfile from './voucher.json';
import {Link, useHistory, useRouteMatch} from "react-router-dom";
import {CisUI, getQueryStrings, SearchObject} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import ActionButton from '../../../../util/actionbutton';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import IntlMessages from "util/IntlMessages";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import {useQueryString} from "../../../../util/useQueryString";

const Panel = Collapse.Panel;

const VoucherList = () => {
    // const value = 0;
    // const [expand, setExpand] = useState(false);
    let pageClick = 0;
    const [form] = Form.useForm();
    const history = useHistory();
    const [data,setData] = useState([]);
    const [isLoading,setisLoading] = useState(false);
    const [stdata,setStdata] = useState([]);
    const [selected,setSelected] = useState([]);
    const [check,setCheck] = useState([]);
    const [searched,setSearched] = useState(false);
    const query = useQueryString();

    let searchParams = window.location.search;
    if (query.get("page") === null) {
        // const currentParams = window.location.search.replace("?", "&");
        // searchParams = "?page=1" + currentParams;
    }
    const [state,setState] = useState({
        reqURL: Config.apiserver+jsonfile.urls.listV2+searchParams,
        filtervalue : '',
        subtitle:''
    });

    const [pages, setPages] = useState({
        current_page: null,
        last_page: null,
        per_page: 50,
        total: null
    });


    useEffect(() => {
        if (searchParams) {
            console.log(searchParams);
            setState({reqURL: Config.apiserver+jsonfile.urls.listV2,searchParams});
            let newObj = (searchParams);
            // form.setFieldsValue(newObj);
            if(searched === false && pageClick === 0) {
                console.log("Searched");
                // getData(Config.apiserver + jsonfile.urls.listV2, searchParams);
            }
        }
        else {
            console.log("No Search");
            getData(state.reqURL);
        }
    }, [form, searchParams]);

    const checkAll = (e) => {

        var ele=document.getElementsByClassName('check_all');

        for(var i=0; i<ele.length; i++){

            if(ele[i].checked === false) {
                ele[i].checked = true;
                selected.push(parseInt(ele[i].value))
            } else {
                ele[i].checked = false;
                selected.pop(parseInt(ele[i].value))
            }
            // ele[i].checked = ele[i].checked === false;

            if(selected.length > 0) {
                document.getElementById("prntbtn").style.display = "block";
                setStdata(Object.values(selected).join(','));
            }
            else {
                document.getElementById("prntbtn").style.display = "none";
                setStdata("");
            }
        }
    }


    const columns = [
        {
            title: <input type="checkbox" onClick={checkAll} id="select_all" style={{marginRight: '10px'}}/>,
            sortable: true,
            key: "id",
            filterable: false,
            render: (_, record, idx) => (
                <input type="checkbox" onChange={selectedForPrint(idx)} name={"ck_"+record.id} value={record.id} className="check_all" />
            )
        },
        {
            title: "Actions",
            sortable: false,
            key: "id",
            filterable: false,
            render: (value, row, idx) => (
                <>
                    {
                        row.status === 0 ? ActionButton(row.id,jsonfile.urls,jsonfile.urls.list) : ""
                    }
                </>
            )
        },
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
            sortable: true,
            filterable: true,
            render: (_, record) => (CisUI().getOrderStatus(record.status))
        },
        {
            title: "Date",
            key: "date",
            sortable: true,
            filterable: true,
            render: (_,record) => (
                <>
                    {
                        CisUI().DateFormat(record?.date || "")
                    }
                </>
            )
        },
        {
            title: "Voucher#",
            key: "invoice_number",
            dataIndex: "invoice_number",
            sortable: true,
            filterable: true,
            render: (_,record) => (
                <>
                    {
                        <Link to={"voucherdetails/"+record.id}>{record.invoice_number}</Link>
                    }
                </>
            )
        },
        {
            title: "Bill#",
            key: "bill_no",
            dataIndex: "bill_no",
            sortable: true,
            filterable: true
        },
        {
            title: "Company Name",
            key: "company_name",
            dataIndex: "company_name",
            sortable: true,
            filterable: true
        },
        {
            title: "Vendor",
            key: "vendor",
            dataIndex: "vendor",
            sortable: true,
            filterable: true
        },
        {
            title: "Account Payable",
            key: "account_payable",
            dataIndex: "account_payable",
            sortable: true,
            filterable: true
        },
        {
            title: "Amount",
            key: "account_payable",
            dataIndex: "account_payable",
            sortable: true,
            filterable: true,
            render: (_, record) => (CisUI().getCurrency(record.total))
        },
        {
            title: "Required By",
            key: "required_by_date",
            dataIndex: "required_by_date",
            sortable: true,
            filterable: true,
            render: (_, record) => (CisUI().DateFormat(record.required_by_date))
        },
        {
            title: "Created By",
            key: "created_at",
            dataIndex: "created_at",
            sortable: true,
            filterable: true,
            render: (_, record) => (CisUI().DateFormat(record.created_at))
        },
        {
            title: "Attachments",
            key: "attachments",
            dataIndex: "attachments",
            sortable: false,
            filterable: false,
            render: (_, record) => (record?.attachments?.length > 0 ? <>
                {
                    record?.attachments?.map((file, fl)=> {
                        return <a href={Config.fileserver+""+file.location} target="_blank" className="btn btn-primary btn-sm btn-circle">
                            <i className="fa fa-file"></i>
                        </a>
                    })
                }
            </> : "")
        }
    ];

    const selectedForPrint = (idx) => e => {
        if(e.target.checked === true) {
            //st[e.target.name] = e.target.value;
            selected.push(e.target.value);

            let chk = [...check];
            console.log(chk);
        }
        else {
            selected.pop(e.target.value);
        }

        if(selected.length > 0) {
            document.getElementById("prntbtn").style.display = "block";
            setStdata(Object.values(selected).join(','));
        }
        else {
            document.getElementById("prntbtn").style.display = "none";
            setStdata("");
        }
    }


    const onFinish = values => {
        let wk = "";
        let dt = "";
        setSearched(true);
        const qs = Object.keys(values).map(key => {
                if (key === 'date') {
                    wk = values['date'];
                    const dt = CisUI().ParseDateFormat(values[key]);
                    // setPeriod("Between "+CisUI().DateFormat(dt[0])+" and "+CisUI().DateFormat(dt[1]));
                    return `${key}=${dt}`
                } else {
                    return `${key}=${values[key]}`
                }
            }
        ).join('&');

        const qsup = qs.replaceAll("undefined", "");
        //reqURL = reqURL+"/?"+qsup;
        history.push("?" + qsup);
        const newURL = Config.apiserver + jsonfile.urls.listV2 + "?" + qsup;

        // console.log(newURL);
        //reqURL = reqURL+"/?"+qsup;
        setState({reqURL: newURL});
        getData(newURL);
    };

    let  searchView = "";
    if(jsonfile.has_search) {
        searchView = <Card className="advance-search-card">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']} >
                <Panel header="Advance Search"  key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch(jsonfile.input,"",1,"date",CisUI().PeriodFiled(form))}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const goForPrint = () => {
        const url = Config.apiserver + "vendor/voucherprint?selected=" + stdata;
        window.open("../../vouchers.html?type=voucherprint&url=" + window.btoa(url) + "&selected=" + stdata, "_blank");
        //showModal();
    }

    const getExtra = (
        <>
            {CisUI().listAction("../"+jsonfile.urls.add, "", state.reqURL, 'data', 'voucher_list', jsonfile, state.subtitle, "landscape")}
        </>
    );

    const getData = (url) => {
        setisLoading(true);
        axios.get(url)
            .then((res) => {
                if(res.data.status === 1) {
                    const lines = res.data.data;
                    setData(lines);
                    setPages(res.data.meta);
                    console.log("Pages:"+ JSON.stringify(res.data.meta));
                }
                setisLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setisLoading(false);
            });
    }


    return (
        <>
            {searchView}
            <Card title={jsonfile.listtitle} extra={getExtra}>
                {/*{CisUI().listAction(jsonfile.urls.add)}*/}

                <div className="row" style={{padding: '10px'}}>
                    <a id="prntbtn" onClick={goForPrint} className="btn btn-primary" style={{width: '100px', display: 'none'}} target="_blank">Print</a>
                </div>

                <Table
                    size="small"
                    className="member-list-table"
                    scroll={{ x: true }}
                    columns={columns}
                    dataSource={data}
                    filterable={true}
                    bordered
                    pagination={{
                        position: ["bottomCenter"],
                        pageSize: 50,
                        showSizeChanger: false,
                        total: pages?.total,
                        current: pages?.current_page,
                        onChange: (page, pageSize) => {
                            console.log(page, pageSize);
                            pageClick = 1;
                            const prevParams = SearchObject(searchParams);
                            prevParams["page"] = page;
                            const qsup = getQueryStrings(prevParams);
                            history.push("?" + qsup);
                            setSearched(false);
                            setState({reqURL: Config.apiserver+jsonfile.urls.listV2+"?"+qsup});
                            getData(Config.apiserver+jsonfile.urls.listV2+"?"+qsup);
                        },
                    }}
                    loading={{ spinning: isLoading, indicator: CisUI().loader }}
                />


            </Card>
        </>
    );
};

export default VoucherList;